import React from 'react';
import { useSelector } from 'react-redux';

const ContactForm = () => {
  const company = useSelector((state) => state.companyReducer.company);
  const address = company.address || {};
  const contactPerson = company.contactPerson || {};

  return (
    <section className="bg-[rgb(8,64,88)] text-white" id="contact">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="mb-4">
          <div className="mb-6 max-w-3xl text-center md:mx-auto md:mb-12">
            <p className="text-base font-semibold uppercase tracking-wide text-white">
              Contact
            </p>
            <h2 className="font-heading mb-4 font-bold tracking-tight text-white text-3xl sm:text-5xl">
              Get in Touch
            </h2>
          </div>
        </div>
        <div className="flex items-stretch justify-center">
          <div className="grid md:grid-cols-2">
            <div className="h-full pr-6">
              <ul className="mb-6 md:mb-0">
                <li className="flex">
                  <div className="flex h-10 w-10 items-center justify-center rounded bg-white text-[rgb(8,64,88)]">
                    📍
                  </div>
                  <div className="ml-4 mb-4">
                    <h3 className="mb-2 text-lg font-medium leading-6 text-white">Our Address</h3>
                    <p>{address.streetName1 || "Street not available"}</p>
                    <p>{address.city || "City not available"}, {address.state || "State not available"}</p>
                  </div>
                </li>
                <li className="flex flex-col gap-4">
                  <div className="flex items-center">
                    <div className="flex h-10 w-10 items-center justify-center rounded bg-white text-[rgb(8,64,88)]">
                      📞
                    </div>
                    <div className="ml-4">
                      <h3 className="mb-2 text-lg font-medium leading-6 text-white">Phone</h3>
                      <p>{contactPerson.phoneNumber || "Not available"}</p>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="flex h-10 w-10 items-center justify-center rounded bg-white text-[rgb(8,64,88)]">
                      📧
                    </div>
                    <div className="ml-4">
                      <h3 className="mb-2 text-lg font-medium leading-6 text-white">Email</h3>
                      <p>{contactPerson.email || "Not available"}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-white text-[rgb(8,64,88)] p-6 md:p-12 rounded-lg">
              <h2 className="mb-4 text-2xl font-bold">Ready to Get Started?</h2>
              <form id="contactForm">
                <div className="mb-6 space-y-4">
                  <input type="email" id="name" placeholder="Your name" className="w-full rounded-md border border-[rgb(8,64,88)] py-3 pl-4 pr-4 shadow-md text-[rgb(8,64,88)]" name="email" />
                  <input type="email" id="email" placeholder="Your email address" className="w-full rounded-md border border-[rgb(8,64,88)] py-3 pl-4 pr-4 shadow-md text-[rgb(8,64,88)]" name="email" />
                  <textarea id="textarea" name="textarea" cols="30" rows="5" placeholder="Write your message..." className="w-full rounded-md border border-[rgb(8,64,88)] py-3 pl-4 pr-4 shadow-md text-[rgb(8,64,88)]"></textarea>
                </div>
                <div className="text-center">
                  <button type="submit" className="w-full bg-[rgb(8,64,88)] text-white px-6 py-3 font-xl rounded-md">Send Message</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
